(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('accountMenu', function($rootScope,
            $location,
            authService,
            urlUtils,
            dateUtil,
            cookieService,
            languageService,
            modalService,
            dashboardNotificationService,
            $route,
            accountMenuService,
            broker,
            postBookingLookup,
            resourceService,
            $window,
            $document) {
    return {
        restrict: 'E',
        replace: true,
        priority: 200,
        templateUrl: (el, attrs) => `partials/home/directivetemplate?type=accountmenu${attrs.forNavigationDrawer === 'true' ? 'sidebar' : ''}`,
        link(scope, el, attrs) {
            let menuOpen = false;

            scope.forNavigationDrawer = (attrs.forNavigationDrawer === 'true');
            scope.IsTouchDevice = $window.TRPCONFIG.IsTouchDevice;

            scope.selectedLanguage = cookieService.get('LANG') || 'en-GB';
            scope.limitAlerts = 2;
            scope.formatNotification = noti => dashboardNotificationService.formatNotification(noti);
            scope.showDashboardMenu = false;
            scope.showNotifications = false;
            scope.showDashboardMenuSidebar = true;
            scope.setLanguage = setLanguage;
            scope.setLanguagePreference = setLanguagePreference;
            scope.sidebarClass = function() { return menuOpen ? 'open' : ''; };
            scope.signOut = signOut;
            scope.user = authService.getUser();
            scope.userName = userName;
            scope.launchNotification = launchNotification;
            scope.notificationClicked = notificationClicked;
            scope.toggleDashboardMenuSidebar = () => scope.showDashboardMenuSidebar = !scope.showDashboardMenuSidebar;
            scope.toggleNotification = () => {
                scope.showNotifications = !scope.showNotifications;
                scope.showDashboardMenu = false;
            };
            scope.toManage = toManage;
            scope.getResourceValue = resource => resourceService.get(resource);
            scope.formatNotification = notification => dashboardNotificationService.formatNotification(notification);

            //For EKH agent website
            scope.launchUserProfileSearch = launchUserProfileSearch;
            scope.launchUserProfileView = launchUserProfileView;
            scope.launchUserProfileCreate = launchUserProfileCreate;
            scope.bookingName = bookingName;
            scope.customerName = customerName;
            scope.manageBooking = manageBooking;
            scope.showSignOutAlert = false;

            scope.$on('auth:signin', function() {
                resetNotifications();
                scope.user = authService.getUser();
            });

            scope.$on('auth:signout', function() {
                menuOpen = false;
                $rootScope.alerts = null;
                scope.user = authService.getUser();
            });

            scope.$on('menuClicked', function() {
                menuOpen = !menuOpen;
                if (menuOpen) {
                    resetNotifications();
                }
            });

            resetNotifications();

            function setLanguagePreference(lang, id) {
                languageService.setLanguage(lang, id)
                    .then(() => {
                        if (TRPCONFIG.Domain.RedirectLanguageChangeToHomepage) {
                            window.location.href = '/?rl=1';
                        } else {
                            //window.location.href = this.$location.absUrl();
                            this.$route.reload();
                        }
                    });
            }

            function setLanguage() {
                cookieService.set('LANG', scope.selectedLanguage, dateUtil.addDays(new Date(), 365));
                window.location.href = $location.absUrl();
            }

            function launchUserProfileSearch() {
                modalService.launch('partials/userprofile/Search', { promptUserSelection: false });
            }

            function launchUserProfileView() {
                modalService.launch('partials/userprofile/UpdateUserProfileModal');
            }

            function launchUserProfileCreate() {
                modalService.launch('partials/userprofile/CreateUserProfileModal');
            }

            function launchNotification() {
                accountMenuService.launchNotification(scope.alerts);
                scope.closeMenu();
            }

            function userName() {
                if (!scope.user) {
                    return '';
                }
                if (scope.user.FirstName && scope.user.LastName) {
                    return `${scope.user.FirstName} ${scope.user.LastName}`;
                }
                let bookingId = authService.getSignedInBookingId();
                if (bookingId && scope.user.Contact && scope.user.Contact.SiteId) {
                    return `${scope.user.Contact.SiteId}/${bookingId}`;
                }
                return scope.user.Email;
            }

            function bookingName() {
                let bookingId = authService.getSignedInBookingId();
                if (bookingId) {
                    return `${this.user.Contact.SiteId}/${bookingId}`;
                }
            }

            function customerName() {
                if (scope.user.SignedIn && scope.user.LastName) {
                    return `${scope.user.FirstName} ${scope.user.LastName}`;
                }
            }

            function manageBooking() {
                if (scope.user.AnonSignedIn) {
                    return postBookingLookup.redirect();
                }
            }

            function resetNotifications() {
                const user = authService.getUser();
                if (TRPCONFIG.Domain.DashboardBookingEnabled && TRPCONFIG.Domain.SideBarNotificationEnabled && (user.AnonSignedIn || user.HardSignedIn)) {
                    dashboardNotificationService.getNotifications()
                        .then(data => $rootScope.alerts = data);
                }
            }

            function notificationClicked(noti) {
                scope.closeMenu();

                scope.showDashboardMenu = false;
                scope.showNotifications = false;

                dashboardNotificationService.notificationClicked(noti);
            }

            function signOut() {
                const isAgentMode = _.get(TRPCONFIG, 'Domain.isAgentMode');
                const enableV3SignIn = _.get(TRPCONFIG, 'Domain.EnableV3SignIn');
                const path = '/v3';
                const currentPath = $location.path();
                const dashboardPath = currentPath && currentPath.startsWith('/dashboard');
                return authService.signOut().then(() => {
                    broker.publish('hideNavigationDrawer');
                    scope.showDashboardMenu = false;
                    if (enableV3SignIn && !isAgentMode && dashboardPath) {
                        const { hostname, protocol } = window.location;
                        let search = window.location.search;
                        if (search) {
                            search = '';
                        }
                        window.location.href = `${protocol}//${hostname}${path}${search}`;
                    }
                });
            }

            function toManage() {
                scope.closeMenu();
                const cookieName = authService.createCookieName();
                authService.doesHttpOnlyCookieExist(cookieName);
                scope.showDashboardMenu = false;
                scope.showNotifications = false;

                if (scope.user.AnonSignedIn && !scope.user.SignedIn) {
                    return postBookingLookup.redirect();
                }
                if (!scope.user.AnonSignedIn && scope.user.SignedIn) {
                    return $location.path('dashboard/bookings/current');
                }
                return accountMenuService.launchOption('bookingsignin');
            }

            scope.subMenuTriggerMouseenter = function(e, booleanName) {
                // open on mouseenter for non-touch only
                if (!scope.forNavigationDrawer && !scope.IsTouchDevice) {
                    scope[booleanName] = true;
                }
            };

            scope.subMenuTriggerMouseleave = function(e, booleanName) {
                // close on mouseleave for non-touch only
                if (!scope.forNavigationDrawer && !scope.IsTouchDevice) {
                    scope[booleanName] = false;
                }
            };

            scope.subMenuTriggerClick = function(e, booleanName) {
                e.preventDefault();
                // toggle on click for touch devices only
                if (!scope.forNavigationDrawer && scope.IsTouchDevice) {
                    scope[booleanName] = !scope[booleanName];
                    if (scope[booleanName]) {
                        e.stopPropagation();
                        // close sub menu when anything else is clicked
                        $document.one('click.accountMenu', () => {
                            scope.$apply(scope[booleanName] = false);
                        });
                    }
                }
            };

            scope.dashboardLinkClick = function() {
                broker.publish('hideNavigationDrawer');
                scope.showDashboardMenu = false;
            };

            scope.hideSignOutAlert = function() {
                scope.showSignOutAlert = false;
            };

            scope.signOutAlert = function() {
                scope.showSignOutAlert = true;
            };

            scope.closeMenu = () => {
                menuOpen = false;
                broker.publish('hideNavigationDrawer');
            };
        }
    };
});
})();
